'use client';

import { c as _c } from "react/compiler-runtime";
import CustomScrollbarOld from '@components/custom-scrollbar/CustomScrollbar';
import CustomScrollbarNew from '@components/custom-scrollbar/CustomScrollbarNew';
import ROUTES from '@lib/constants/routes';
import { COOKIE_SECURE_FORMA_29680, SCROLL_FORMA_32412 } from '@lib/flags';
import BaseLayoutOld from '@lib/layouts/BaseLayout';
import BaseLayoutNew from '@lib/layouts/BaseLayoutNew';
import BaseMobileLayout from '@lib/layouts/BaseMobileLayout';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import { emailFormSelector, handleIsLoading, videoModalSelector } from '@lib/store/slices/ComponentsSlice';
import { handleNewUser } from '@lib/store/slices/UserSlice';
import { handleBodyLock } from '@lib/tools/_handle-body-lock';
import { handleBodyUnlock } from '@lib/tools/_handle-body-unlock';
import isBrowserOutdated from '@lib/tools/_is_browser_outdated';
import { CookieStorage } from '@lib/tools/helpers/CookieStorage';
import useModalService from '@lib/tools/hooks/useModalsService';
import dynamic from 'next/dynamic';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnimationWrapper from './components/animation-wrapper/AnimationWrapper';
import { ScrollToTop } from './components/scroll-to-top/ScrollToTop.jsx';
const PanoramaModal = dynamic(() => import('@components/panorama-modal/PanoramaModal'));
const ModalError = dynamic(() => import('@components/modal-error/ModalError'));
const ModalEmail = dynamic(() => import('@components/modal-email/ModalEmail'));
const FormModal = dynamic(() => import('@components/form-modal/FormModal'));
const VideoModal = dynamic(() => import('@components/video-modal/VideoModal'));
const BaseLayout = SCROLL_FORMA_32412 ? BaseLayoutNew : BaseLayoutOld;
const CustomScrollbar = SCROLL_FORMA_32412 ? CustomScrollbarNew : CustomScrollbarOld;
const applyRenderFooter = [ROUTES.gallery];
function getCookie(cname) {
  if (typeof window === 'undefined') return '';
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    while (ca[i].charAt(0) === ' ') {
      ca[i] = ca[i].slice(1);
    }
    if (ca[i].indexOf(name) === 0) {
      return ca[i].slice(name.length, ca[i].length);
    }
  }
  return '';
}
function Template(t0) {
  const $ = _c(58);
  const {
    children
  } = t0;
  const [width, setWidth] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const openEmailForm = useSelector(emailFormSelector);
  const {
    isMobile,
    deviceType
  } = useDeviceScreen();
  const router = useRouter();
  const pathname = usePathname();
  const dispatch = useDispatch();
  const {
    modelError,
    modelForm,
    menu,
    menuMobile,
    emailForm,
    filterMenu,
    panoramaModel
  } = useModalService();
  const isANewUser = useSelector(_temp);
  const videoModal = useSelector(videoModalSelector);
  let t1;
  if ($[0] !== pathname) {
    t1 = applyRenderFooter.includes(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderFooter = !t1;
  let t2;
  if ($[2] !== pathname) {
    t2 = pathname.includes("visual");
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const showCustomScrollbar = !t2;
  const BaseLayoutComponent = isMobile ? BaseMobileLayout : BaseLayout;
  const hasMenuOpen = menu || menuMobile || filterMenu;
  const hasFormOpen = modelForm || emailForm;
  const hasModelError = modelError || panoramaModel;
  const handleChangeWidth = _temp2;
  let t3;
  if ($[4] !== dispatch) {
    t3 = () => {
      if (typeof window === "undefined") {
        return;
      }
      if (COOKIE_SECURE_FORMA_29680 ? CookieStorage.has("moments_user") : getCookie("moments_user")) {
        dispatch(handleNewUser(true));
      }
    };
    $[4] = dispatch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isANewUser) {
    t4 = [isANewUser];
    $[6] = isANewUser;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== hasFormOpen || $[9] !== hasMenuOpen || $[10] !== hasModelError) {
    t5 = () => {
      if (typeof window === "undefined") {
        return;
      }
      if (hasModelError || hasFormOpen || hasMenuOpen) {
        handleBodyLock();
      } else {
        handleBodyUnlock();
      }
      return _temp3;
    };
    $[8] = hasFormOpen;
    $[9] = hasMenuOpen;
    $[10] = hasModelError;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== emailForm || $[13] !== filterMenu || $[14] !== menu || $[15] !== menuMobile || $[16] !== modelError || $[17] !== modelForm || $[18] !== panoramaModel) {
    t6 = [modelError, modelForm, menu, menuMobile, emailForm, filterMenu, panoramaModel];
    $[12] = emailForm;
    $[13] = filterMenu;
    $[14] = menu;
    $[15] = menuMobile;
    $[16] = modelError;
    $[17] = modelForm;
    $[18] = panoramaModel;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  useEffect(t5, t6);
  let t7;
  if ($[20] !== dispatch || $[21] !== pathname || $[22] !== router || $[23] !== width) {
    t7 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const timerId = setTimeout(() => {
        dispatch(handleIsLoading(true));
      }, 300);
      if (isBrowserOutdated()) {
        router.push(ROUTES.notSupported);
        return;
      }
      if (!pathname.includes("progress")) {
        window.addEventListener("resize", handleChangeWidth(width, setWidth));
        window.addEventListener("orientationchange", handleChangeWidth(width, setWidth));
      }
      if (width < 640) {
        setLoaded(true);
      } else {
        setTimeout(() => {
          setLoaded(true);
        }, 2000);
      }
      return () => {
        clearTimeout(timerId);
        window.removeEventListener("resize", handleChangeWidth(width, setWidth));
        window.removeEventListener("orientationchange", handleChangeWidth(width, setWidth));
      };
    };
    $[20] = dispatch;
    $[21] = pathname;
    $[22] = router;
    $[23] = width;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  useEffect(t7, t8);
  let t9;
  if ($[26] !== openEmailForm) {
    t9 = openEmailForm && <ModalEmail />;
    $[26] = openEmailForm;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ModalError />;
    t11 = <FormModal />;
    $[28] = t10;
    $[29] = t11;
  } else {
    t10 = $[28];
    t11 = $[29];
  }
  let t12;
  if ($[30] !== videoModal) {
    t12 = videoModal && <VideoModal />;
    $[30] = videoModal;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== panoramaModel) {
    t13 = panoramaModel && <PanoramaModal />;
    $[32] = panoramaModel;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t9) {
    t14 = <>{t9}{t10}{t11}{t12}{t13}</>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t9;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const commonModals = t14;
  let t15;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ScrollToTop />;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== BaseLayoutComponent || $[40] !== children || $[41] !== commonModals || $[42] !== deviceType || $[43] !== isANewUser || $[44] !== isMobile || $[45] !== loaded || $[46] !== menuMobile || $[47] !== pathname || $[48] !== renderFooter) {
    t16 = <BaseLayoutComponent loaded={loaded} setLoaded={setLoaded} isANewUser={isANewUser} menuMobile={menuMobile} children={children} pathname={pathname} renderFooter={renderFooter} commonModals={commonModals} deviceType={deviceType} isMobile={isMobile} />;
    $[39] = BaseLayoutComponent;
    $[40] = children;
    $[41] = commonModals;
    $[42] = deviceType;
    $[43] = isANewUser;
    $[44] = isMobile;
    $[45] = loaded;
    $[46] = menuMobile;
    $[47] = pathname;
    $[48] = renderFooter;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== pathname || $[51] !== t16) {
    t17 = <AnimationWrapper path={pathname}>{t16}</AnimationWrapper>;
    $[50] = pathname;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== showCustomScrollbar) {
    t18 = showCustomScrollbar && <CustomScrollbar />;
    $[53] = showCustomScrollbar;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== t17 || $[56] !== t18) {
    t19 = <>{t15}{t17}{t18}</>;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  return t19;
}
function _temp3() {
  return handleBodyUnlock();
}
function _temp2(width_0, setWidth_0) {
  const delta = width_0 - window.innerWidth;
  if (delta > 100 || delta < 0) {
    setWidth_0(window.innerWidth);
  }
  return null;
}
function _temp(state) {
  return state.userinfo.isANewUser;
}
export default Template;